import './Showlessonsmodel.css';
  import '../home.css';

  import { useState, useEffect, useRef } from 'react';
  import certificate from '../../header/images/certificate.png'
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
  import { faFlagCheckered, faPuzzlePiece, faArrowUp, faArrowDown, faFileLines, faBookOpen, faShareNodes, faDumbbell, faForwardFast, faPlay } from '@fortawesome/free-solid-svg-icons';
  import { useNavigate, useLocation, Link } from 'react-router-dom';
  import bazeleconta from '../../imagesHome/bazeleconta.png';
 import GetProCard from './rightelements/GetProCard';
 import LeaderboardCard from './rightelements/LeaderboardCard';
import DailyGoalsCard from './rightelements/DailyGoalsCard';
  import safebadge from '../../imagesHome/giftclosed.png';
    import brainreview from '../../imagesHome/brain_review.png';
    import chaptericon from '../../imagesHome/chapter_icon.png';
     import trophy from '../../imagesHome/trophy.png';
      import road from '../../imagesHome/road.png';
       import finish from '../../imagesHome/finish.png';
        import diploma from '../../imagesHome/progress-card.png';
        import FooterElements from './rightelements/FooterElements';
        import SocialElements from './rightelements/SocialElements';
    // moved to showlessonsmodel.jsx (lowercase)
    import './SidebarMenuItems/reglaredimensiune.css';



      

  
  import { FloatingLessonBubble} from '../lessonstyles/FloatingLessonBubble';




  import LessonSeparator from '../lessonstyles/LessonSeparator';





  import StatsCard from './popupsright/StatsCard';


  export const ShowLessonsModel = () => {
    const [showLessonsMain, setShowLessonsMain] = useState(true);
    const [activePanel, setActivePanel] = useState(null);



    const getPanelKey = (chapter, lessonId) => `chapter-${chapter}-lesson-${lessonId}`;

const [floatingLesson, setFloatingLesson] = useState(null);

const scrollerRef = useRef(null);


const [showInitialFloating, setShowInitialFloating] = useState(false);

const floatingPanelWrapperRef = useRef(null);
const skipNextScrollClose = useRef(false);
const isUserScrolling = useRef(false);

const scrollProtectorRef = useRef(false);
const [isActiveLessonVisible, setIsActiveLessonVisible] = useState(true);
const [scrollDirectionUp, setScrollDirectionUp] = useState(false);
const congratsRef = useRef(null);
const [hideScrollButton, setHideScrollButton] = useState(false);
const [loadingLesson, setLoadingLesson] = useState(false);







const [isDesktop, setIsDesktop] = useState(() =>
  typeof window !== 'undefined' && window.matchMedia('(min-width: 1121px)').matches
);

useEffect(() => {
  const mql = window.matchMedia('(min-width: 1121px)');
  const onChange = (e) => setIsDesktop(e.matches);
  mql.addEventListener?.('change', onChange);
  return () => mql.removeEventListener?.('change', onChange);
}, []);

const prevLessonRef = useRef(null);









const lessonRefs = useRef({});                  




useEffect(() => {
  const updateColumnPosition = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    document.documentElement.style.setProperty('--lesson-column-left', `${rect.left}px`);
  };

  updateColumnPosition();
  window.addEventListener('resize', updateColumnPosition);
  window.addEventListener('scroll', updateColumnPosition, { passive: true });

  return () => {
    window.removeEventListener('resize', updateColumnPosition);
    window.removeEventListener('scroll', updateColumnPosition);
  };
}, []);



useEffect(() => {
  const el = scrollerRef.current;
  if (!el) return;

  const setVars = () => {
    const r = el.getBoundingClientRect();
    const root = document.documentElement.style;
    root.setProperty('--lesson-col-left', `${r.left}px`);
    root.setProperty('--lesson-col-right', `${window.innerWidth - r.right}px`);
    root.setProperty('--lesson-col-width', `${r.width}px`);
  };

  setVars();

  // ținem valorile la zi când se schimbă layoutul
  const ro = new ResizeObserver(setVars);
  ro.observe(el);

  window.addEventListener('resize', setVars);
  window.addEventListener('scroll', setVars, { passive: true });

  return () => {
    ro.disconnect();
    window.removeEventListener('resize', setVars);
    window.removeEventListener('scroll', setVars);
  };
}, []);



    const panelRef = useRef(null);
    const lessonButtonRef = useRef(null);

    const unhideLessons = () => setShowLessonsMain(!showLessonsMain);

    const [chapters, setChapters] = useState([]);
    
    const [titles, setTitles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageLoading, setPageLoading] = useState(true);

   




    const location = useLocation();
    const { updatedProgress } = location.state || {};

    const fromStart = location.state?.fromStart || false;

const [showWelcome, setShowWelcome] = useState(fromStart);

    const tothelesson = useNavigate();

    const [lessonProgress, setLessonProgress] = useState({});

    

    const [activeChapters, setActiveChapters] = useState({});

const justClosedRef = useRef(false);
    

    const getLessonStatus = (chapterId, lessonId) => {
      const key = `${chapterId}-${lessonId}`;
      const status = lessonProgress[key];
    
      if (!status || !status.unlocked) return 'locked';
      if (status.completed) return 'completed';
      return 'unlocked';
    };
    
    


  useEffect(() => {
  const timeout = setTimeout(() => {
    setShowWelcome(false);
  }, 3000);

  return () => clearTimeout(timeout);
}, []);







    //cere titlul
    useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}/chapters/titles`, {
        credentials: 'include'
      })
        .then(res => res.json())
        .then(data => {
          setTitles(data);
          setLoading(false);
        })
        .catch(err => {
          console.error('Eroare la fetch:', err);
          setLoading(false);
        });
    }, []);



// cere lectiile
useEffect(() => {
  // 1. Încarcă capitolele
  fetch(`${process.env.REACT_APP_API_URL}/chapters`, {
    credentials: 'include'
  })
    .then((res) => res.json())
    .then((data) => {
      setChapters(data.chapters);
      const activeByDefault = {};
      const progressUnlocked = {};
      data.chapters.forEach((chapter, chapterIndex) => {
        activeByDefault[chapterIndex] = true;
        chapter.lessons.forEach((lesson, lessonIndex) => {
          const key = `${chapter.id}-${lesson.lesson}`;
          const isFirstLesson = chapterIndex === 0 && lessonIndex === 0;
          const isJumpHere = lesson.explanationType?.toLowerCase() === 'jumphere';
          progressUnlocked[key] = {
            unlocked: isFirstLesson || isJumpHere,
            completed: false,
          };
        });
      });
      setActiveChapters(activeByDefault);
      // 2. După ce am capitolele, cerem statusul lecțiilor completate
      fetch(`${process.env.REACT_APP_API_URL}/user/lesson-progress`, {
        credentials: 'include'
      })
        .then(res => res.json())
     .then(completedLessons => {

  const completedSet = new Set(
    completedLessons.map(
      l => `${l.chapter_id}-${l.lesson_id}`
    )
  );

  const updatedProgress = {};

  data.chapters.forEach((chapter, chapterIndex) => {
    chapter.lessons.forEach((lesson, lessonIndex) => {

      const key = `${chapter.id}-${lesson.lesson}`;
      const isCompleted = completedSet.has(key);

      const isFirstLesson = chapterIndex === 0 && lessonIndex === 0;

      const prevLesson =
        lessonIndex > 0
          ? `${chapter.id}-${chapter.lessons[lessonIndex - 1].lesson}`
          : null;

      const isUnlocked =
        isFirstLesson ||
        isCompleted ||
        (prevLesson && completedSet.has(prevLesson));

      updatedProgress[key] = {
        completed: isCompleted,
        unlocked: isUnlocked
      };
    });
  });

  setLessonProgress(updatedProgress);
})

        .catch(err => {
          // Dacă nu merge fetch-ul, măcar să nu blocheze restul
          setLessonProgress(progressUnlocked);
        });
    })
    .catch((err) => {
      console.error('Eroare la fetch capitole:', err);
    });
}, []);


// Oprește loading-ul paginii când ambele fetch-uri sunt complete
useEffect(() => {
  if (!loading && chapters.length > 0) {
    // Adaugă un mic delay pentru o tranziție plăcută
    const timer = setTimeout(() => {
      setPageLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }
}, [loading, chapters]);

// Functia handleLessonClick trebuie sa fie definita inainte de a fi folosita in JSX
const handleLessonClick = async (chapterId, lessonId) => {
  setLoadingLesson(true);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/chapter/${chapterId}/lesson/${lessonId}`,
      { credentials: 'include' }
    );

    let lessonData = {};

    if (response.ok) {
      lessonData = await response.json();
    } else {
      lessonData = {
        title: "Lecție indisponibilă",
        content: "Această lecție nu este încă disponibilă."
      };
    }

    tothelesson('/chaptercontainer', {
      state: { chapterId, lessonId, lessonData }
    });

  } catch (error) {
    tothelesson('/chaptercontainer', {
      state: {
        chapterId,
        lessonId,
        lessonData: {
          title: "Eroare",
          content: "Nu am putut încărca lecția."
        }
      }
    });
  } finally {
    setLoadingLesson(false);
  }
};


// Asigură-te că handleClickOutside este definit (mută-l mai sus dacă e necesar)

// scroll → închide panelul

// useEffect corectat sau eliminat dacă nu e folosit




useEffect(() => {
  if (!floatingLesson) return;

  const lessonKey = `${floatingLesson.chapterId}-${floatingLesson.lessonId}`;
  const lessonEl = lessonRefs.current[lessonKey];

  if (lessonEl) {
    skipNextScrollClose.current = true;
    isUserScrolling.current = false;

    // ⚠️ Găsim containerul scrollabil
const scrollableContainer = scrollerRef.current;


    if (scrollableContainer) {
      const containerRect = scrollableContainer.getBoundingClientRect();
      const lessonRect = lessonEl.getBoundingClientRect();

      const offsetTop = lessonRect.top - containerRect.top;
      const centeredScroll = offsetTop + scrollableContainer.scrollTop - scrollableContainer.clientHeight / 2 + lessonRect.height / 2;

      scrollableContainer.scrollTo({
        top: centeredScroll,
        behavior: 'smooth',
      });
    }

    setTimeout(() => {
      skipNextScrollClose.current = false;
    }, 500);
  }
}, [floatingLesson]);



useEffect(() => {
  if (justClosedRef.current) {
    const timeout = setTimeout(() => {
      justClosedRef.current = false;
    }, 300); // delay suficient

    return () => clearTimeout(timeout);
  }
}, [floatingLesson]);




useEffect(() => {
  const handleClickOutside = (event) => {
  setTimeout(() => {
    if (
      floatingPanelWrapperRef.current &&
      !floatingPanelWrapperRef.current.contains(event.target)
    ) {
      setFloatingLesson(null);
    }
  }, 0);
};

  if (floatingLesson) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [floatingLesson]);





useEffect(() => {
  const handleUserScroll = () => {
    isUserScrolling.current = true;
    // Close floating lesson panel if open
    if (floatingLesson) {
      setFloatingLesson(null);
    }
  };

  window.addEventListener('wheel', handleUserScroll, { passive: true });
  window.addEventListener('touchmove', handleUserScroll, { passive: true });

  return () => {
    window.removeEventListener('wheel', handleUserScroll);
    window.removeEventListener('touchmove', handleUserScroll);
  };
}, [floatingLesson]);



useEffect(() => {
  if (!floatingLesson) {
    isUserScrolling.current = false;
  }
}, [floatingLesson]);


    const getLessonIconColor = (status) => {
      switch (status) {
        case 'locked':
          return '#9ca3af'; // gri
        case 'unlocked':
          return '#9ca3af'; // gri
        case 'completed':
          return '#22c55e'; // verde
        default:
          return '#10b981'; // fallback: mentă
      }
    };
    

const getFirstAvailableLessonKey = () => {
  for (const key in lessonProgress) {
    const status = lessonProgress[key];
    if (status.unlocked && !status.completed) {
      return key;
    }
  }
  return null;
};

const [firstAvailableLessonKey, setFirstAvailableLessonKey] = useState(null);

useEffect(() => {
  if (!Object.keys(lessonProgress).length) return;

  const firstKey = Object.entries(lessonProgress).find(
    ([, status]) => status?.unlocked && !status?.completed
  );

  if (firstKey) {
    setFirstAvailableLessonKey(firstKey[0]);
  }
}, [lessonProgress]);


const hasAutoScrolled = useRef(false);

useEffect(() => {
  if (!firstAvailableLessonKey || hasAutoScrolled.current) return;

  const scroller = scrollerRef.current;
  const lessonEl = lessonRefs.current[firstAvailableLessonKey];

  if (!scroller || !lessonEl) return;

  hasAutoScrolled.current = true;

  const timer = setTimeout(() => {
    const containerRect = scroller.getBoundingClientRect();
    const lessonRect = lessonEl.getBoundingClientRect();

    const offsetTop = lessonRect.top - containerRect.top;

    scroller.scrollTo({
      top: offsetTop - scroller.clientHeight / 3,
      behavior: 'smooth'
    });
  }, 300);

  return () => clearTimeout(timer);
}, [firstAvailableLessonKey]);



useEffect(() => {
  if (!justClosedRef.current) return;

  const timer = setTimeout(() => {
    justClosedRef.current = false;
  }, 300);

  return () => clearTimeout(timer);
}, [justClosedRef.current]);


useEffect(() => {
  if (floatingLesson === null) {
    const timer = setTimeout(() => {
      justClosedRef.current = false;
    }, 300);

    return () => clearTimeout(timer);
  }
}, [floatingLesson]);




useEffect(() => {
  const key = firstAvailableLessonKey;
  const lessonEl = lessonRefs.current[key];
  const scroller = scrollerRef.current;

  if (!key || !lessonEl || !scroller) return;

  const updatePosition = () => {
    const lessonRect = lessonEl.getBoundingClientRect();
    const buttonEl = document.querySelector('.scroll-to-active-lesson-bc');

    // ✅ Determină dacă lecția e vizibilă
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isVisible =
      lessonRect.top >= 0 &&
      lessonRect.bottom <= windowHeight;

    setIsActiveLessonVisible(isVisible);

    // ✅ Determină direcția
    if (buttonEl) {
      const buttonTop = buttonEl.getBoundingClientRect().top;
      setScrollDirectionUp(lessonRect.top < buttonTop); // 🧠 dacă lecția e mai sus decât butonul, arătăm în sus
    }
  };

  // ✅ Rulează inițial (după un frame)
  const raf = requestAnimationFrame(updatePosition);

  // ✅ Rulează la scroll
  const onScroll = () => {
    updatePosition();
  };

  const scrollContainer = scrollerRef.current || window;
  scrollContainer.addEventListener('scroll', onScroll, { passive: true });

  return () => {
    cancelAnimationFrame(raf);
    scrollContainer.removeEventListener('scroll', onScroll);
  };
}, [firstAvailableLessonKey]);



useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      setHideScrollButton(entry.isIntersecting);
    },
    {
      root: null, // se uită în viewport-ul paginii
      threshold: 0.1,
    }
  );

  if (congratsRef.current) {
    observer.observe(congratsRef.current);
  }

  return () => {
    if (congratsRef.current) {
      observer.unobserve(congratsRef.current);
    }
  };
}, []);






    const getLessonLeftIconColor = (lesson) => {
      const type = lesson.explanationType || lesson.title;
    
      if (type.toLowerCase().includes('practica')) return 'rgba(255, 255, 255, 1)';
      if (type.toLowerCase().includes('aplicatie')) return '#ffffffff';
      if (type.toLowerCase().includes('lectie')) return '#ffffffff';
       if (type.toLowerCase().includes('introducere')) return '#ffffffff';
      if (type.toLowerCase().includes('avanseaza')) return '#ffffffff';
      if (type.toLowerCase().includes('safebadge')) return '#ffffffff';
      if (type.toLowerCase().includes('recapitulare')) return '#ffffffff';

      


      if (type.toLowerCase().includes('test')) return 'rgba(255, 255, 255, 1)';
      return '#ffffffff';
    };
    
    
    const getLessonLeftIcon = (lesson) => {
      const type = lesson.explanationType?.toLowerCase() || lesson.title?.toLowerCase();
    
      if (type.includes('practica')) return faDumbbell;
      if (type.includes('aplicatie')) return faPuzzlePiece;
      if (type.includes('test')) return faFlagCheckered;
      if (type.includes('lectie')) return faFileLines; 
        if (type.includes('introducere')) return faPlay; 
      if (type.includes('jumphere')) return faForwardFast; 
      if (type.includes('safebadge')) return faForwardFast; 
      if (type.includes('recapitulare')) return faForwardFast; 
      return faBookOpen; // fallback general
    };
    




    return (
      <div className="componentsmenu-container-main">
      <div className="componentsmenu-left-blank-lessons"></div>
     

        
      {pageLoading && (
        <div className="welcome-screen-lesson">
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      {loadingLesson && (
        <div className="welcome-screen-lesson">
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      
    
        <div className='container-show-lessons'>
           
          <div>
            {showLessonsMain && (

            <div className='body-lessons-bc-framework'>







              <div className='line-lesson-gackground-functional' ref={scrollerRef}>


  <div className="chapter-header-sticky-wrapper-stats">
                  <div className="statscard-sticky">
                    <StatsCard />
                  </div>
                  </div>
                


            {chapters.map((chapter, index) => (
              <div key={chapter.id} className="chapter-block">

                {/* HEADER capitol sticky wrapper */}
                <div className="chapter-header-sticky-wrapper">
                
                  <div className='chapter-containerbc'>
                    <div className='db-data-title-button'>
                      <p className='modul-name'>{chapter.module}</p>
                      <p className='title-modul-name'>{chapter.title}</p>
                    </div>
                    <div className='button-right-chapter'>
                      <img src={chaptericon} />
                    </div>
                  </div>
                </div>

              

                {/* LECTII capitol */}
              <div className={`chapter-lessons-wrapper ${activeChapters[index] ? 'displaying-show-chapters' : 'displaying-none-chapters'}`}>



{chapter.lessons?.map((lesson, idx) => {
  const k = `${chapter.id}-${lesson.lesson}`;
  const lessonIdStr = String(lesson.lesson);
  const chapterIdStr = String(chapter.id);
  const clickedLessonKey = `${chapterIdStr}-${lessonIdStr}`;
  const currentLessonKey = floatingLesson
    ? `${floatingLesson.chapterId}-${floatingLesson.lessonId}`
    : null;

  // O lecție este activă dacă este prima deblocată și nefinalizată
  const isActiveLesson = firstAvailableLessonKey === `${chapter.id}-${lesson.lesson}`;
  // O lecție este completată dacă lessonProgress[k]?.completed === true
  const isCompleted = lessonProgress[k]?.completed;
  // O lecție este dezactivată dacă nu este activă și nu este completată
  const isInactive = !isActiveLesson && !isCompleted;
  const isFirstAvailable = firstAvailableLessonKey === `${chapter.id}-${lesson.lesson}`;
  const isCenterLesson = String(floatingLesson?.chapterId) === String(chapter.id) &&
                         String(floatingLesson?.lessonId) === String(lesson.lesson);

  const pattern = ['align-center-odd', 'align-left', 'align-center-even', 'align-left', 'align-center-odd', 'align-right-four', 'align-right'];
  const serpentineClass = pattern[idx % pattern.length];

  return (
    <>
      <div
        key={lesson.lesson}
        className={`serpentine-wrapper ${serpentineClass} ${isCenterLesson ? 'selected-wrapper' : ''}`}
      >
        <div
          className={`lesson-show-mainbc ${isCenterLesson ? 'selected-lesson' : ''}`}
          ref={(el) => { lessonRefs.current[k] = el; }}
          style={isInactive ? { filter: 'grayscale(1)', opacity: 0.5 } : {}}
        >








<div className="symbol-lesson">
  {/* 🔵 Cercul START – apare DOAR la prima lecție deblocată */}
  {isFirstAvailable && lesson.explanationType?.toLowerCase() !== 'jumphere' && !isCenterLesson && floatingLesson === null && (
    <div className="start-bubble-wrapper">
      <FloatingLessonBubble />
    </div>
  )}

  {/* 🟢 Cercul cu iconiță – trebuie să fie mereu vizibil */}

  <div className={`costomize-icon-lesson ${isFirstAvailable ? 'glow-effect' : ''}`}>
    <div
 className={`align-items-lessons-inside-show
  ${lesson.explanationType?.toLowerCase() === 'safebadge' ? 'no-inner-bg' : ''}
  ${lesson.explanationType?.toLowerCase() === 'recapitulare' ? 'recap-lesson' : ''}
  ${lesson.explanationType?.toLowerCase() === 'jumphere' ? 'jump-here-lesson' : ''}
`}



onClick={(event) => {
  event.stopPropagation();

  const lessonIdStr = String(lesson.lesson);
  const chapterIdStr = String(chapter.id);
  const clickedLessonKey = `${chapterIdStr}-${lessonIdStr}`;
  const currentLessonKey = floatingLesson
    ? `${floatingLesson.chapterId}-${floatingLesson.lessonId}`
    : null;

  // Toggle OFF
  if (clickedLessonKey === currentLessonKey) {
    setFloatingLesson(null);
    return;
  }

  // PROTECȚIE scroll
  scrollProtectorRef.current = true;
  skipNextScrollClose.current = true;
  isUserScrolling.current = false;

  // Delay de 0ms pentru ca scrollProtector să fie activ
  setTimeout(() => {
    setFloatingLesson({
      chapterId: chapterIdStr,
      lessonId: lessonIdStr,
      title: lesson.title,
    });
  }, 0);

  setTimeout(() => {
    scrollProtectorRef.current = false;
  }, 600);
}}





    >
    {lesson.explanationType?.toLowerCase() === 'safebadge' ? (
  <img
    src={safebadge}
    alt="Safe Badge"
    className="safebadge-icon"
  />
) : lesson.explanationType?.toLowerCase() === 'recapitulare' ? (
  <img
    src={brainreview}
    alt="Recapitulare"
    className="recapitulare-icon-bc"
  />
) : lesson.explanationType?.toLowerCase() === 'jumphere' ? (
  <FontAwesomeIcon
    icon={faForwardFast}
    className="symbol-item-lesson-jump-bc"
    style={{ color: getLessonLeftIconColor(lesson) }}
  />
) : (
  <FontAwesomeIcon
    icon={getLessonLeftIcon(lesson)}
    className="symbol-item-lesson"
    style={{ color: getLessonLeftIconColor(lesson) }}
  />
)}



    </div>




  </div>

  {!floatingLesson && <span className="lesson-title-right">{lesson.title}</span>}
</div>


{isCenterLesson && (
  <>
    <div className="arrow-floating" />

    <div ref={floatingPanelWrapperRef}>
      <div className="floating-panel-over-lesson-floating" data-position={serpentineClass}>
        <div className="panel-card-floating">
          <p className="lesson-title-floating">{lesson.title}</p>
          <p className="lesson-subtitle-floating">
            {lessonProgress && lessonProgress[`${chapter.id}-${lesson.lesson}`]?.completed
              ? 'completata'
              : isCenterLesson
                ? 'activa'
                : lesson.explanationType}
          </p>

          <div
            className="start-lesson-btn-floating"
            onClick={() => handleLessonClick(chapter.id, lesson.lesson)}
          >
            {lessonProgress && lessonProgress[`${chapter.id}-${lesson.lesson}`]?.completed ? 'Refa lectia' : 'Start'}
          </div>
        </div>
      </div>
    </div>
  </>
)}




      </div>
    </div>

    {/* 🔹 Separator după fiecare 7 lecții */}
      {
        ((index === 0
            ? ((idx + 1 === 12) || (idx + 1 > 12 && (idx - 11) % 11 === 0))
            : ((idx + 1) % 11 === 0)
        )) && (
          <LessonSeparator key={`separator-${idx}`} text={`Ai parcurs ${idx + 1} lecții`} />
        )
      }

    </>
  );
})}


  



</div>

              </div>
            ))}




<div className='congratuation' ref={congratsRef}>

  <img src={road} className='road'/>
  <img src={finish} className='finish'/>

<div className='gray-line-before-share' />

  <div className='share-progress'>
    <img src={trophy} className='trophy'/>
    <div className='social-progress'>
      <FontAwesomeIcon icon={faShareNodes} /> Distribuie progresul

    </div>
    <img src={trophy} className='trophy'/>
  </div>

<div className='gray-line-before-share' />






  
</div>

             <div className='obtain-certificate-bc'>
            <img src={diploma} alt="certificate" className="disabled-image-bc" />
            
         <Link to="/diploma" className="buton-diploma-bc">
  Vezi diploma!
</Link>

          </div>

     
{firstAvailableLessonKey && !isActiveLessonVisible && !hideScrollButton && (

  <div
    className="scroll-to-active-lesson-bc"
onClick={() => {
  const scroller = scrollerRef.current;
  const el = lessonRefs.current[firstAvailableLessonKey];

  if (!scroller || !el) return;

  const containerRect = scroller.getBoundingClientRect();
  const lessonRect = el.getBoundingClientRect();

  const offsetTop =
    lessonRect.top - containerRect.top + scroller.scrollTop;

  scroller.scrollTo({
    top: offsetTop - scroller.clientHeight / 3,
    behavior: 'smooth'
  });
}}


    aria-label="Mergi la lecția activă"
  >
    <FontAwesomeIcon
      icon={scrollDirectionUp ? faArrowUp : faArrowDown}
      className="icon-arrow-active-bc"
    />
  </div>
)}






              </div>


 


            </div>



             )}

            



          </div>
          
        </div>
        <div className="right-elements-componentsmenu">
        <GetProCard />
        <LeaderboardCard />
        <DailyGoalsCard />
          <FooterElements />
      <SocialElements />
        </div>



      </div>
    );
  };

export default ShowLessonsModel;